  // TODO: PUT ALL CONSTANTS IN ONE FILE

  // UI display
  export const PERU = 'Peru';

  // serviceResponses fields
  export const PERU_NATIONAL_ID = 'Peru National ID';
  export const PERU_RESIDENTIAL = 'Peru Residential';
  export const PERU_TAX_REGISTRATION = 'Peru Tax Registration';